export default __webpack_public_path__ + "static/N0126-3c9638bdc00d7437814f1da5f93e87a3.png";